import styled from "@emotion/styled";
import { KalturaESearchCategoryResult } from "kaltura-typescript-client/api/types/KalturaESearchCategoryResult";
import { SearchCategory } from "./../../../types";
import { addBaseUrl } from "@kaltura/mediaspace-shared-utils";
import { Tag, tagClasses } from "@kaltura/ds-react-components";

export interface GalleryItemProps {
    searchResult: KalturaESearchCategoryResult;
}

const StyledGalleryItem = styled(Tag)(({ theme }) => ({
    [`&.${tagClasses.root}`]: {
        maxWidth: "initial",
        width: "100%",
        height: theme.spacing(4),
    },
}));

const StyledLi = styled("li")(({ theme }) => ({
    display: "block",
    width: "100%",
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
        width: "33.33%",
        flexBasis: "33.33%",
        maxWidth: "33.33%",
    },
}));

/**
 * single gallery search result
 */
export function GalleryItem({ searchResult }: GalleryItemProps) {
    const category = searchResult.object as unknown as SearchCategory;
    const { name, url } = category;

    return (
        <StyledLi>
            <StyledGalleryItem component={"a"} href={addBaseUrl(url)} label={name} />
        </StyledLi>
    );
}

export default GalleryItem;
